import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';

import AccountProfile from "../Accounts/Profile";
import AccountChildren from "../Accounts/Children";
import AccountPayments from "../Accounts/Payments";
import AccountInvoices from "../Accounts/Invoices";
import AccountReceipts from "../Accounts/Receipts";
import AccountAgreements from "../Accounts/Agreements";
import AccountDocuments from "../Accounts/Documents";
import AccountAuditLog from "../Accounts/AuditLog";
import { formatNumber } from '@telerik/kendo-intl';

export default function accountBreadcrumb<T extends RouteComponentProps>(
    WrappedComponent: React.ComponentType<T>,
    fetchAccountName: (childId: number) => Promise<any>,
    options: { page?: string } = { }
) {

    type State = {
        accountId: number;
        accountName: string;
        balance: number;
        links: ApiLink[];
    }

    type Props = RouteComponentProps<{ accountId: string }>;

    return class extends React.Component<Props, State> {

        constructor(props: Props) {
            super(props);

            this.state = {
                accountId: 0,
                accountName: '',
                balance: 0,
                links: []
            }

            this.open = this.open.bind(this);
        }

        componentDidMount() {
            const accountId = parseInt(this.props.match.params.accountId);
            fetchAccountName(accountId)
                .then((response) => {
                    this.setState({ ...response });
                })
        }

        componentWillReceiveProps(nextProps: Props) {
            const accountId = parseInt(nextProps.match.params.accountId);

            if (accountId !== this.state.accountId) {
                fetchAccountName(accountId)
                    .then((response) => {
                        this.setState({ ...response });
                    })
            }
        }

        render() {
            return <React.Fragment>
                <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to='/accounts'>Accounts</Link>
                    </li>
                    {!options.page && <li className="breadcrumb-item active" aria-current="page">{this.state.accountName}</li>}
                    {options.page && <React.Fragment>
                        <li className="breadcrumb-item">
                            <Link to={`/accounts/${this.props.match.params.accountId}`}>{this.state.accountName || 'Account'}</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            {options.page}
                        </li>
                    </React.Fragment>}
                </ol>
                </nav>
                <ul className="nav nav-tabs d-print-none">
                    {this.state.links.find(x => x.Rel === "Profile") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === AccountProfile.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Profile"))}
                        >
                            Profile
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Children") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === AccountChildren.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Children"))}
                        >
                            Children
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Payments") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === AccountPayments.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Payments"))}
                        >
                            Payments
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Invoices") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === AccountInvoices.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Invoices"))}
                        >
                            Invoices
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Receipts") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === AccountReceipts.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Receipts"))}
                        >
                            Receipts
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Agreements") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === AccountAgreements.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Agreements"))}
                        >
                            Agreements
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Documents") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === AccountDocuments.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Documents"))}
                        >
                            Documents
                        </a>
                    </li>}
                    {this.state.links.find(x => x.Rel === "Logs") && <li className="nav-item">
                        <a
                            href="#"
                            className={`nav-link${WrappedComponent.prototype === AccountAuditLog.prototype ? ' active' : ''}`}
                            onClick={(e) => this.open(e, this.state.links.find(x => x.Rel === "Logs"))}
                        >
                            Logs
                        </a>
                    </li>}
                    
                    <li className="nav-item" style={{ flex: 'auto' }}>
                        <a
                            href="#"
                            className={`nav-link disabled float-right${this.state.balance > 0 ? ' text-success' : this.state.balance < 0 ? ' text-danger' : ''}`}
                        >
                            {this.state.balance < 0 ? '(' + formatNumber(-this.state.balance, "c") + ')' : formatNumber(this.state.balance, "c")}
                        </a>
                    </li>
                </ul>
                <WrappedComponent {...(this.props as T)} />
            </React.Fragment>
        }

        private open(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, link: ApiLink | undefined): void {
            if (link) {
                e.preventDefault();
                this.props.history.push(link.Href);
            }
        }
    };
}
